





















import {
  computed,
  defineNuxtComponent,
  ref,
  vue3Model,
  watch
} from '~/utils/nuxt3-migration'
import { useNamespacedStore } from '~/compositions/store'
import {
  CLASSIFIED_SEARCH_NS,
  SearchState
} from '~/store/modules/shared/classifieds/search/state'
import { defineComponentTranslations } from '~/utils/i18n'

export default defineNuxtComponent({
  model: vue3Model,
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const {
      state: classifiedSearchState,
      dispatch: classifiedSearchDispatch
    } = useNamespacedStore<SearchState>(CLASSIFIED_SEARCH_NS)

    const visible = ref(props.modelValue)
    const saveSearchName = ref('')
    const saveSearchReplace = ref(false)
    const saveSearchLoading = ref(false)

    const previousSearch = computed(() => classifiedSearchState.previousSearch)

    watch(
      () => props.modelValue,
      (newValue: boolean) => {
        visible.value = newValue
      }
    )

    function onHide() {
      saveSearchName.value = ''
      saveSearchReplace.value = false

      emit('update:modelValue', false)
    }

    async function onConfirmSaveSaveButtonClick() {
      saveSearchLoading.value = true
      await classifiedSearchDispatch('addToFavorites', {
        name: saveSearchName.value,
        replaceSearch: saveSearchReplace.value
      })
      emit('update:modelValue', false)
      saveSearchLoading.value = false
    }

    return {
      saveSearchLoading,
      previousSearch,
      saveSearchName,
      saveSearchReplace,
      visible,
      onHide,
      onConfirmSaveSaveButtonClick
    }
  },
  i18n: defineComponentTranslations({
    search_name: {
      en: 'Search name (optional)',
      el: 'Όνομα αναζήτησης (προαιρετικό)'
    },
    replace_previous_search: {
      en: 'Replace previous search',
      el: 'Αντικατάσταση προηγούμενης αναζήτησης'
    }
  })
})
